




































































import { Component, Vue } from 'vue-property-decorator';
import router from '../router';
import { MedTransGoConstants } from '../util/constants';
import { validationMixin } from 'vuelidate';
import { required, minLength, numeric, alpha, maxLength } from 'vuelidate/lib/validators';
import { ACHAccount } from '../types/request';
import {EventBus} from '../main';
import { ToastEvent } from '../types/event';
declare global {
    interface Window { Stripe: any; }
}
@Component({
 mixins: [validationMixin],
 data() {
    return {
        accountHolderType: 'individual',
        accountHolderName: '',
        accountNumber: '',
        routingNumber: '',
        currency: '',
        country: '',
    };
 },
 validations: {
    accountHolderName: {
      required,
      regex: (accountHolderName) => /^[a-zA-Z0-9 ]+$/.test(accountHolderName),
    },
    accountNumber: {
        required,
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(17),
    },
    routingNumber: {
        required,
        numeric,
        minLength: minLength(9),
        maxLength: maxLength(9),
    },
    currency: {
        alpha,
    },
    country: {
        alpha,
    },
 },
})
export default class ACHAccountForm extends Vue {

    private async getSource() {
        this.$emit(MedTransGoConstants.EVENT_CHANGE, '');
        if (!this.$v.$invalid) {
            const achAccount: ACHAccount = {
                account_holder_name: this.$data.accountHolderName,
                account_holder_type: this.$data.accountHolderType,
                routing_number: this.$data.routingNumber,
                account_number: this.$data.accountNumber,
                currency: this.$data.currency || 'USD',
                country: this.$data.country || 'US',
            };
            const stripe = window.Stripe(this.$store.state.stripePublicKey);
            const result = await stripe.createToken('bank_account', achAccount);
            if (result.error) {
                const toastEvent: ToastEvent = {
                    message: result.error.message,
                    title: 'Payment Error',
                    timeout: 5000,
                    varient: 'danger',
                };
                EventBus.$emit(MedTransGoConstants.EVENT_SHOW_TOAST, toastEvent);
            } else {
                const paymentSource = result.token.id;
                this.$emit(MedTransGoConstants.EVENT_CHANGE, paymentSource);
            }
        }
    }

}
